import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import DyncPopovers from 'dync-popovers'
import Loading from '@dynapp/wc-api-loading';
import DyncAuth from 'dync-auth'
import DyncDataitems from 'dync-dataitems';
import DyncNews from 'dync-news'
import DyncVideoio from 'dync-videoio'
import DyncStatistics from 'dync-statistics'
import DyncMessages from 'dync-messages';
import DyncBookingKeys from 'dync-bookingkeys';
import DyncUsers from 'dync-users';
import DyncAuction from 'dync-auction';
import DyncCoupon from 'dync-coupon';
import DyncAgenda from 'dync-agenda';
import DyncPush from 'dync-push'
import DyncProperties from 'dync-properties';
import SeatingInput from './components/SeatingInput.vue';
import thePotCustomBooking from './plugins/thePotCustomBooking'
import digiergeMessages from './messages'
import Vuetify from 'vuetify/lib/framework';
import vuetifyEn from 'vuetify/lib/locale/en';
import vuetifySv from 'vuetify/lib/locale/sv';

Vue.use(DyncMessages);

const messages = {
  en: {
    $vuetify: vuetifyEn,
    ...digiergeMessages.en
  },
  sv: {
    $vuetify: vuetifySv,
    ...digiergeMessages.sv
  }
};
Vue.use(DyncMessages);
const dyncMessages = DyncMessages.init(Vue, {
  messages,
  locale: 'sv',
  fallbackLocale: 'en',
  fetchMessages: true
});

Vue.use(Vuetify);
const vuetify = new Vuetify({
  theme: {
    dark: false,
    themes: {
      light: {
        primary: '#7b3284',
        accent: '#7b3284',
        secondary: '#7b3284'
      },
      dark: {
        primary: '#7b3284',
        accent: '#7b3284',
        secondary: '#7b3284'
      }
    }
  },
  lang: {
    t: (key, ...params) => {
      return dyncMessages.translate(key, params)
    }
  }
});

Vue.use(DyncPopovers, { vuetify, dyncMessages });
Vue.use(DyncDataitems, { store });
Vue.use(Loading, { store });
Vue.use(DyncAuth, { store,  router, usersDataObject: 'dync-users-web'});
Vue.use(DyncPush, { store, router });
Vue.use(DyncProperties, {store, router});

Vue.use(thePotCustomBooking, {store, router})

Vue.use(DyncBookingKeys, {
  store,
  router,
  keysOptions: {
    iosInstallLink: store.getters['dync-properties/get']('digierge', 'ios_install_link'),
    androidInstallLink: store.getters['dync-properties/get']('digierge', 'android_install_link')
  }
});

Vue.use(DyncNews, { store, router,
  defaultModuleOptions: {
    props: {
      departmentsEnabled: true,
      videoioEnabled: true
    }
  }
});
Vue.use(DyncStatistics, { store, router, Vue });
Vue.use(DyncUsers, { store, router });
Vue.use(DyncAuction, { store, router });
Vue.use(DyncCoupon, { store, router });
Vue.use(DyncAgenda, { store, router, props: {departmentsEnabled: true}});
Vue.use(DyncVideoio, { store, router });

Vue.config.productionTip = false
Vue.component('seating-input', SeatingInput);

new Vue({
  router,
  store,
  vuetify,
  dyncMessages,
  render: h => h(App)
}).$mount('#app')
